import type { Cents } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';

// TODO jason
//   Move to shared package _after_ IM launch

export enum RetirementContributionType {
    TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
    REGULAR = 'REGULAR',
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYER = 'EMPLOYER',
    RECHARACTERIZATION = 'RECHARACTERIZATION',
    ROLLOVER_60_DAY = 'ROLLOVER_60_DAY',
    ROLLOVER_DIRECT = 'ROLLOVER_DIRECT',
    TRANSFER = 'TRANSFER',
    TRUSTEE_FEE = 'TRUSTEE_FEE',
    CONVERSION = 'CONVERSION',
    REPAYMENT = 'REPAYMENT',
    CONTRIBUTION_NON_REPORTABLE = 'CONTRIBUTION_NON_REPORTABLE',
}

export interface RetirementContribution {
    taxYear: number;
    type: RetirementContributionType;
}

export interface AdminICTDepositRequest {
    userId: string;
    fromSyncteraAccountId: string;
    toApexAccountId: string;
    amountCents: Cents;
    memo?: string;
    retirementContribution?: RetirementContribution;
}

export interface AdminICTDepositResponse {
    completed: boolean;
    workflowId: string;
    idempotencyKey: string;
    expectedSettlementDate?: string;
    state: string;
    stateMessage: string;
    stateMetadata: {
        actor: string;
        message: string;
    };
}

const useAdminICTDeposit = requestBuilder.mutation<
    AdminICTDepositResponse,
    AdminICTDepositRequest
>({
    endpoint: '/api/admin/ict/deposit',
    method: 'POST',
});

export default useAdminICTDeposit;
